import { render } from "./myorder.vue?vue&type=template&id=430f3701&scoped=true"
import script from "./myorder.vue?vue&type=script&lang=js"
export * from "./myorder.vue?vue&type=script&lang=js"

import "./myorder.vue?vue&type=style&index=0&id=430f3701&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-430f3701"]])

export default __exports__